// extracted by mini-css-extract-plugin
export default {"navbar":"Sidebar_navbar__RoJvG","icon":"Sidebar_icon__7LhDe","main":"Sidebar_main__S97Ey","button":"Sidebar_button__qHweE"};